/* everstory-cart-addon.js — the in-drawer "Add unlimited revisions" button.
   Rendered by snippets/everstory-addon.liquid. Adds the Revisions variant to the
   cart and re-renders Dawn's cart drawer in place. Event delegation so it survives
   the drawer's innerHTML re-renders. */
(function () {
  function getDrawer() { return document.querySelector('cart-drawer'); }

  function sectionIds(drawer) {
    try { return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','); }
    catch (e) { return 'cart-drawer,cart-icon-bubble'; }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-everstory-addon-add]');
    if (!btn) return;
    e.preventDefault();

    var box = btn.closest('[data-everstory-addon]');
    if (!box || box.dataset.busy) return;
    box.dataset.busy = '1';
    btn.disabled = true;
    btn.classList.add('is-loading');

    var id = parseInt(box.dataset.addonId, 10);
    var drawer = getDrawer();
    var secs = drawer ? sectionIds(drawer) : 'cart-drawer,cart-icon-bubble';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    postJSON(root + 'cart/add.js', { items: [{ id: id, quantity: 1 }], sections: secs })
      .then(function (parsed) {
        try {
          // everstory-reskin.js owns the one forwarder (Shopify analytics plus Meta); fall back to
          // the bus alone if this script somehow runs without it.
          if (window.EverstoryTrack) {
            window.EverstoryTrack('everstory_addon_add', { variant: id, value: 5, currency: 'EUR' });
          } else if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('everstory_addon_add', { variant: id });
          }
        } catch (e) {}
        if (drawer && typeof drawer.renderContents === 'function' && parsed && parsed.sections) {
          drawer.renderContents(parsed);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); });
  });
})();
